// Source: https://ourcodeworld.com/articles/read/189/how-to-create-a-file-and-generate-a-download-with-javascript-in-the-browser-without-a-server
export function downloadAsFile(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function downloadProfilingData(sessionInfo, appVersion) {
  const perfEntries = performance.getEntriesByType('measure').map(entry => ({
    name: entry.name,
    start: Math.round(entry.startTime * 100) / 100,
    duration: Math.round(entry.duration * 100) / 100,
  }))
    // All major steps follow naming convention "x. description"
    .filter(entry => entry.name[1] === '.')

  const data = {
    user: sessionInfo.loggedInAs,
    system: navigator.platform,
    browser: navigator.userAgent,
    organizer: appVersion,
    performance: perfEntries
  }

  const processing = performance.getEntriesByName('Total processing')
  const totalWait = performance.getEntriesByName('Total wait time')
  if (processing.length && totalWait.length) {
    // Filter out substeps like "x.y. description"
    const withoutSubsteps = perfEntries.filter(entry => entry.name[2] === ' ')
    const timeAccountedFor = withoutSubsteps
      .map(entry => entry.duration)
      .reduce((a, b) => a + b, 0)
    const unaccounted = totalWait[0].duration - timeAccountedFor
    Object.assign(data, {
      'Total processing': Math.round(processing[0].duration),
      'Total wait time': Math.round(totalWait[0].duration),
      'unaccounted time': Math.round(unaccounted),
    })
  }

  const serialized = JSON.stringify(data, null, 2)
  downloadAsFile('performance-log', serialized)
}

export function countComponentsRecursively(startComponent) {
  function count(component, countDict) {
    for (const child of component.$children) {
      const name = child.$vnode.componentOptions.tag
      if (countDict[name] === undefined) {
        countDict[name] = 1
      } else {
        countDict[name] = countDict[name] + 1
      }
      count(child, countDict)
    }
  }
  let dict = {};
  let array = [];
  let total = 0;
  count(startComponent, dict);
  for (const [key, value] of Object.entries(dict)) {
    array.push([key, value]);
    total += value;
  }
  array.push(['TOTAL', total]);
  array.sort((a, b) => b[1] - a[1]);
  return array;
}

export function avgPerfMeasurements(entryName) {
  let entries = performance.getEntriesByName(entryName).map(
    obj => obj.duration
  )
  // Discard first measurement as it is usually inaccurate.
  entries = entries.slice(1)
  if (!entries.length) return;

  console.group(entryName + ":")
  console.log(entries.map(x => parseFloat(x.toFixed(2))))
  if (entries.length > 1) {
    const average = l => l.reduce((a, b) => a + b, 0) / l.length;
    const avg = average(entries).toFixed(1)
    const avg5 = average(entries.slice(-5)).toFixed(1)
    console.log(`averages: all = ${avg}, last 5 = ${avg5}`)
  }
  console.groupEnd()
}

export function logDashboardPerformance(rootVue) {
  performance.measure('building dashboard', 'dashboard start', 'dashboard end');
  if (rootVue.debug) avgPerfMeasurements('building dashboard')
  // first dashboard creation should be marked specially
  if (rootVue.firstRun) {
    performance.measure('6. building dashboard', 'dashboard start', 'dashboard end');
    rootVue.firstRun = false
  }
}

export async function measureTime(callback, ...args) {
  const name = callback.name
  performance.mark(name + '-start')
  const result = await callback(...args)
  performance.mark(name + '-stop')
  const m = performance.measure(name, name + '-start', name + '-stop')
  console.log("time:", m.duration.toFixed(2), "ms, result:", result)
  return result
}

export function block(miliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < miliseconds);
}
